import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { notificationComponents } from "../../../config";
import { useLayoutEffect } from "react";
import { setGlobalBackHandler } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import StandardNotificationDetail from "../../notificationDetailsV2/StandardNotificationDetail";

const DynamicNotificationDetail: React.FC = () => {
    const categoryCode = useSelector((state: RootState) => state.notification.selectedCategoryForDetails);
    const navigate = useNavigate();

    useLayoutEffect(() => {
        setGlobalBackHandler(() => {
            navigate(-1);
        });
    }, [navigate]);

    if (!categoryCode || !notificationComponents[categoryCode]) {
        return <StandardNotificationDetail />;
    }
    const Component = notificationComponents[categoryCode];

    return <Component />;
};

export default DynamicNotificationDetail;
